//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { DefaultTheme, css } from 'styled-components';

export const CAMPAIGN_REQUEST_TABLE_CAPTION_ID = 'table-caption-campaigns';

export const DEFAULT_EMPTY_VALUE = 'No information provided';

export const DATE_FORMAT = 'MMM DD YYYY, h:mma';

export const DEFAULT_MIN_FOLLOWER_COUNT = 0;
export const DEFAULT_MAX_FOLLOWER_COUNT = 1_000_000; // TODO PD-247263 - change it if it'll be different from product team

export const CREATORS_PROGRAM_TEXT = 'Social Creators';

export const DEFAULT_MIN_AGE = 13;
export const DEFAULT_MAX_AGE = 100;

// Tooltips section
export const CREATORS_CAMPAIGN_REQUESTS_UPDATE_BASICS_TOOLTIPS = {
  BUDGET:
    'Enter the maximum amount of money you’re willing to pay creators to submit content in your campaign.',
  DESCRIPTION:
    'Enter a description of your campaign. We may edit this description before inviting creators to your campaign.',
  TITLE:
    'Enter a name for your campaign. We may edit this name before inviting creators to your campaign.',
  IMAGES: 'Upload images we can use in your campaign.',
};

export const CREATORS_CAMPAIGN_REQUESTS_ADD_NEW_PRODUCT_TOOLTIPS = {
  PRODUCT_ID: `Enter the product's unique product ID.`,
  PRODUCT_NAME: 'Enter the name of the product.',
  PRODUCT_DESCRIPTION: 'Enter a detailed description of the product.',
  BRAND: 'Enter the name of your brand.',
  CATEGORY: 'Enter the category to which the product belongs.',
  PDP_WEB_ADDRESS: `Enter the web address for the product's Product Detail Page (PDP).`,
  QUANTITY: 'Enter the total available quantity of the product.',
  PRICE: `Enter the product's fair market value.`,
};

export const CREATORS_CAMPAIGN_REQUESTS_UPDATE_AUDIENCE_TOOLTIPS = {
  ADDITIONAL_INFORMATION:
    'Enter information to help us find suitable creators for this campaign. For example, demographics, interests, or content submission style.',
  CREATOR_INSPIRATION:
    'Upload example media of the type of content you want creators to submit in this campaign. Creators will use this media to help inform their content creation.',
};

export const CREATORS_CAMPAIGN_REQUESTS_UPDATE_TASKS_TOOLTIPS = {
  USE_CONTENT_ON_CHANNEL:
    'Let us know if you plan to use content created in this campaign in your social media channels or websites.',
  ADDITIONAL_INFORMATION:
    'Tell us how you plan to use content submitted in this campaign. We will use these details to create usage rights contracts for creators.',
};

export const PAGINATION_OPTIONS = [8, 16, 32, 64];
export const DEFAULT_PAGE_SIZE = 8;
export const DEFAULT_PAGE_NUMBER = 0;

// PRODUCTS TABLE
// TODO: PD-247263 - Use the typical pagination size of 8.
export const PRODUCTS_PAGINATION_OPTIONS = [10, 20, 40, 80];
export const PRODUCTS_DEFAULT_PAGE_SIZE = 10;

// Product Identifier Titles to use in Product Tables
export const PRODUCT_IDENTIFIER_TITLE_WITH_PRODUCT_ID_AND_VARIANT_ID =
  'product-id / variant-id';
export const PRODUCT_IDENTIFIER_TITLE_WITH_PRODUCT_ID_AND_DESCRIPTION =
  'product-id / description';
export const PRODUCT_IDENTIFIER_TITLE_WITH_ONLY_PRODUCT_ID = 'product-id';

export const PRODUCT_IDENTIFIER_TITLE_WITH_ONLY_DESCRIPTION = 'description';

// The default suffix that shopify based urls have
export const SHOPIFY_SHOP_URL_DOMAIN_SUFFIX = '.myshopify.com';

// COLUMNS WIDTH
// General column width settings for various components

// General width for number columns
export const WIDTH_NUMBER = ({ theme }: { theme: DefaultTheme }) => css`
  width: calc(${theme.spacings[3]} * 6);
`;

// General width for sortable number columns
export const WIDTH_SORTABLE_NUMBER = ({
  theme,
}: {
  theme: DefaultTheme;
}) => css`
  width: calc(${theme.spacings[3]} * 7);
`;

// General width for product name columns
export const WIDTH_PRODUCT_NAME = ({ theme }: { theme: DefaultTheme }) => css`
  width: calc(${theme.spacings[6]} * 6);
`;

// Selected Products Section
// Specific column width settings for the selected products table

// Width for image columns in the selected products table
export const WIDTH_IMAGE = css`
  width: 100px;
`;

// Width for status columns in the selected products table
export const WIDTH_STATUS = ({ theme }: { theme: DefaultTheme }) => css`
  width: calc(${theme.spacings[3]} * 6);
`;

// Width for actions columns in the selected products table
export const WIDTH_ACTIONS = ({ theme }: { theme: DefaultTheme }) => css`
  width: calc(${theme.spacings[3]} * 4);
`;

// Width for product columns in the selected products table in summary page
export const WIDTH_SUMMARY_PRODUCT = ({
  theme,
}: {
  theme: DefaultTheme;
}) => css`
  width: ${theme.mediumMeasure};
`;

// Width for source columns in the selected products table in summary page
export const WIDTH_SUMMARY_PRODUCT_SOURCE = ({
  theme,
}: {
  theme: DefaultTheme;
}) => css`
  width: calc(${theme.spacings[3]} * 10);
`;
